module.exports = __webpack_public_path__ + "static/walkieImage@3x-495352f0ff92b9dc8d8f82318b3f3f7c.png";